/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Check/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Acknowledge from './Acknowledge/index'
import CheckNumber from './CheckNumber/index'
import Payer from './Payer/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Check({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Widget/Check"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Check.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-4GGpz': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<Payer
  viewPath={`${viewPath}/Payer`}
/>
<CheckNumber
  viewPath={`${viewPath}/CheckNumber`}
/>
<Acknowledge
  viewPath={`${viewPath}/Acknowledge`}
/>
</div>
{children}
</React.Fragment>)
}